import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { createEmployerRemittanceReportFile, emailEmployerRemittanceReport } from '../../services/reportServices';
import { printPreviewReportWithBase64 } from '../../utils/payrollRunUtils';
import { setNotificationData } from '../../redux/global/globalReducer';
import { Modal, Space } from 'antd';
import { MODAL_OPTIONS } from '../../constants';
import { PrinterOutlined, MailOutlined } from '@ant-design/icons';

function EmployerRemittanceReportMenuModal({
  modal,
  toggle,
  payrollRun,
  args
}) {
  const dispatch = useDispatch();
  const accountId = useSelector((state) => state.auth.user.accountId);
  const selectedAccountState = useSelector((state) => state.account.selectedAccount);
  const email = useSelector((state) => state.auth.user.email);

  const sendEmployerRemittanceReport = async () => {
    const payload = {
      payrollRunId: payrollRun.payrollRunId,
      accountId: selectedAccountState.accountId === null ? accountId : selectedAccountState.accountId,
      toEmail: email,
      subject: 'Employer Remittance Report',
      body: 'Report attached here',
      attachmentFileName: 'Employer Remittance Report'
    };

    const response = await emailEmployerRemittanceReport(payload);
    const data = await response.json();

    if (!_.isNil(data.errorMessage)) {
      dispatch(
        setNotificationData({
          type: `error`,
          message: `Error!`,
          description: data.errorMessage,
        })
      );
      return;
    }

    dispatch(
      setNotificationData({
        type: `${response.ok ? "success" : "error"}`,
        message: `${response.ok ? "Success!" : "Error!"}`,
        description: `${response.ok ? "Successfully emailed" : "Failed to email"
          } employer remittance report.`,
      })
    );
  }

  const printEmployerRemittanceReport = async () => {
    const payload = {
      payrollRunId: payrollRun.payrollRunId,
      accountId: selectedAccountState.accountId === null ? accountId : selectedAccountState.accountId
    };

    const response = await createEmployerRemittanceReportFile(payload);
    const data = await response.json();

    if (!_.isNil(data.errorMessage)) {
      dispatch(
        setNotificationData({
          type: `error`,
          message: `Error!`,
          description: data.errorMessage,
        })
      );
      return;
    }

    printPreviewReportWithBase64(data.base64);
  }

  return (
    <Modal
      open={modal}
      className={`ant-modal-color-4`}
      style={{ top: MODAL_OPTIONS.top }}
      title={
        <Space>
          Employer Remittance Report
        </Space>
      }
      onCancel={toggle}
      footer={
        <>
          <div className='modal-header-container d-flex flex-row-reverse align-items-center'>
            <button className="btn btn-md btn-color-4 inverted w-50" onClick={printEmployerRemittanceReport}><PrinterOutlined /> &nbsp;  Print</button>
            <button className="btn btn-md btn-color-4 inverted me-2 w-50" onClick={sendEmployerRemittanceReport}><MailOutlined /> &nbsp; Email</button>
          </div>
        </>
      }
    >
    </Modal>
  )
}

export default EmployerRemittanceReportMenuModal